<template>
    <v-col cols="12" md="6" lg="5">
      <v-row>
        <v-col cols="12" lg="5" md="6" sm="4">
          <global-MultipleSelect 
            ref="stallHoldersRef" 
            :label="labelStallHolders" 
            :dataList="allStallHoldersList" 
            :itemText="StallHolderName" 
            :itemValue="StallHolderId"
            :singleSelect="singleSelect"
            @checkSelectedList="handleSelectedList">
          </global-MultipleSelect>
        </v-col>
        <v-col cols="12" lg="5" md="6" sm="4">
          <global-MultipleSelect 
            ref="stallRef" 
            :label="labelStall" 
            :dataList="stalls" 
            :itemText="StallName" 
            :itemValue="StallId" 
            :isDisable="isDisableStall"
            :singleSelect="singleSelect"
            @checkSelectedList="handleSelectedListTerminal">
          </global-MultipleSelect>
        </v-col>
        </v-row>
        <v-row class="mt-n9">
        <v-col v-if="showTerminals" cols="12" lg="5" md="6" sm="6">
          <global-MultipleSelect 
            ref="terminalNumberRef" 
            :label="labelTerminalNumber" 
            :dataList="terminal" 
            :itemText="terminalName" 
            :itemValue="terminalId" 
            :isDisable="isDisableTerminals"
            :singleSelect="singleSelect"
            @checkSelectedList="handleSelectedListTerminals">
          </global-MultipleSelect>
        </v-col>
      </v-row>
    </v-col>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'StallholderFilterGroup',
  props: {
    showTerminals: {
      type: Boolean,
      default: true
    },
    singleSelect: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('filter', [
      'globalEventFilter',
      'searchStallholders',
      'searchStalls',
      'searchTerminals'
    ]),
    allStallHoldersList() {
      return this.globalEventFilter?.Stallholders || [];
    },
    isDisableTerminals() {
      return this.terminal.length === 0;
    },
    isDisableStall() {
      return this.stalls.length === 0;
    }
  },
  data() {
    return {
      labelStallHolders: 'Stallholders',
      StallHolderName: 'StallholderName',
      StallHolderId: 'StallholderId',
      labelStall: 'Stall',
      StallName: 'StallName',
      StallId: 'StallId',
      labelTerminalNumber: 'Terminal Number',
      terminalName: 'TerminalNumber',
      terminalId: 'TerminalId',
      stalls: [],
      terminal: []
    };
  },
  watch: {
    'globalEventFilter.EventId'(newVal) {
      if (newVal) {
        this.$emit('event-changed');
      }
    },
    stalls: {
      handler(newStalls) {
        // Initialize stalls selection when stalls array is populated
        if (this.searchStalls && this.searchStalls !== 'notSet' && newStalls.length > 0) {
          const selectedStalls = newStalls.filter(
            s => this.searchStalls.includes(s.StallId)
          );
          if (selectedStalls.length > 0) {
            this.$nextTick(() => {
              const pick = this.singleSelect
                ? selectedStalls.slice(0, 1)
                : selectedStalls;
              this.$refs.stallRef.selectedList = this.singleSelect
                ? pick[0]
                : pick;
              this.handleSelectedListTerminal(
                pick.map((s) => s.StallId),
                false
              );
            });
          }
        }
      },
      immediate: true
    },
    terminal: {
      handler(newTerminals) {
        // Initialize terminals selection when terminals array is populated
        if (this.showTerminals && this.searchTerminals && 
            this.searchTerminals !== 'notSet' && newTerminals.length > 0) {
          const selectedTerminals = newTerminals.filter(
            t => this.searchTerminals.includes(t.TerminalId) || this.searchTerminals.includes(t.TermId)
          );
          if (selectedTerminals.length > 0) {
            this.$nextTick(() => {
              const pick = this.singleSelect ? [selectedTerminals[0]] : selectedTerminals;
              this.$refs.terminalNumberRef.selectedList = this.singleSelect
                ? pick[0]
                : pick;
              this.handleSelectedListTerminals(
                pick.map(t => t.TerminalId || t.TermId)
              );
            });
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.initializeSelections();
  },
  methods: {
    ...mapMutations('filter', {
      setSearchStallholders: 'setSearchStallholders',
      setSearchStalls: 'setSearchStalls',
      setSearchTerminals: 'setSearchTerminals'
    }),

    initializeSelections() {
      // Initialize stallholders from Vuex state if values exist
      if (this.searchStallholders && 
          this.searchStallholders !== 'notSet' && 
          this.globalEventFilter?.Stallholders) {
        const selectedStallholders = this.globalEventFilter.Stallholders.filter(
          sh => this.searchStallholders.includes(sh.StallholderId)
        );
        if (selectedStallholders.length > 0) {
          this.$nextTick(() => {
            const pick = this.singleSelect
              ? selectedStallholders.slice(0, 1)
              : selectedStallholders;
            this.$refs.stallHoldersRef.selectedList = this.singleSelect
              ? pick[0]
              : pick;
            this.handleSelectedList(
              pick.map((sh) => sh.StallholderId),
              false
            );
          });
        }
      }
    },

    handleSelectedList(value, shouldResetDependents = true) {
      // Enforce single selection when required
      if (this.singleSelect && value.length > 1) {
        value = [value[value.length - 1]];
      }
      // Update stalls array for UI
      // value is an array of StallholderId strings (emitted by MultipleSelect via itemValue)
      // so look up the full stallholder objects to access their Stalls arrays
      this.stalls = [];
      if (value.length > 0) {
        const fullObjects = this.allStallHoldersList.filter(sh =>
          value.includes(sh.StallholderId)
        );
        fullObjects.forEach((obj) => {
          (obj.Stalls || []).forEach((data) => {
            this.stalls.push(data);
          });
        });
      }

      // Update Vuex state
      // value is already an array of StallholderId strings (emitted by MultipleSelect with itemValue)
      this.setSearchStallholders(value.length > 0 ? value : 'notSet');
      
      // Always clear dependent selections if stallholders are cleared
      if (value.length === 0 || shouldResetDependents) {
        this.setSearchStalls('notSet');
        this.setSearchTerminals('notSet');
        this.terminal = [];
        
        // Clear UI selections
        if (this.$refs.stallRef) {
          this.$refs.stallRef.selectedList = this.singleSelect ? null : [];
        }
        if (this.showTerminals && this.$refs.terminalNumberRef) {
          this.$refs.terminalNumberRef.selectedList = this.singleSelect ? null : [];
        }
      }
    },

    handleSelectedListTerminal(value, shouldResetDependents = true) {
      if (this.singleSelect && value.length > 1) {
        value = [value[value.length - 1]];
      }
      // Update terminals array for UI
      // value is an array of StallId strings (emitted by MultipleSelect with itemValue)
      if (this.showTerminals) {
        this.terminal = [];
        if (value.length > 0) {
          const fullStalls = this.stalls.filter(s => value.includes(s.StallId));
          fullStalls.forEach((stall) => {
            if (stall.Terminals) {
              stall.Terminals.forEach((terminal) => {
                this.terminal.push(terminal);
              });
            }
          });
        }
      }

      // Update Vuex state
      // value is already an array of StallId strings
      this.setSearchStalls(value.length > 0 ? value : 'notSet');
      
      // Always clear terminals if stalls are cleared
      if (value.length === 0 || (shouldResetDependents && this.showTerminals)) {
        this.setSearchTerminals('notSet');
        
        // Clear UI selection
        if (this.$refs.terminalNumberRef) {
          this.$refs.terminalNumberRef.selectedList = this.singleSelect ? null : [];
        }
      }
    },

    handleSelectedListTerminals(value) {
      if (!this.showTerminals) return;
      if (this.singleSelect && value.length > 1) {
        value = [value[value.length - 1]];
      }
      
      // Update Vuex state
      // value is already an array of TermId strings (emitted by MultipleSelect with itemValue)
      this.setSearchTerminals(value.length > 0 ? value : 'notSet');
      
      // Emit that filters have been updated
      this.$emit('filters-updated');
    },

    /** Reset stallholder/stall/terminal Vuex + MultipleSelect UI (Clear button). */
    clearSelections() {
      this.stalls = [];
      this.terminal = [];
      this.setSearchStallholders('notSet');
      this.setSearchStalls('notSet');
      this.setSearchTerminals('notSet');

      const empty = this.singleSelect ? null : [];
      if (this.$refs.stallHoldersRef) {
        this.$refs.stallHoldersRef.selectedList = empty;
      }
      if (this.$refs.stallRef) {
        this.$refs.stallRef.selectedList = empty;
      }
      if (this.showTerminals && this.$refs.terminalNumberRef) {
        this.$refs.terminalNumberRef.selectedList = empty;
      }
    }
  }
};
</script> 